export const TESTIMONIALS = [
  {
    name: "Priya Nair",
    city: "Mumbai, Maharashtra",
    quote:
      "I had been postponing my will for years. WillSeva made it effortless — I generated a draft in 10 minutes and had the senior lawyer team review it. Truly a seva.",
  },
  {
    name: "Rohan Kapoor",
    city: "Bandra West, Mumbai",
    quote:
      "The process respected our family's structure and the lawyer review caught nuances I would have missed entirely. Highly recommended.",
  },
  {
    name: "Ananya Iyer",
    city: "Chennai, Tamil Nadu",
    quote:
      "My parents are in Kerala, property in Bangalore, family in Chennai. WillSeva helped me put everything into one clean, well-drafted document — finally I have clarity.",
  },
  {
    name: "Amit Rao",
    city: "Pune, Maharashtra",
    quote:
      "No hidden charges, no jargon, no pressure. The will was professionally drafted and the Senior Advocate's review gave me complete peace of mind.",
  },
  {
    name: "Sameer Desai",
    city: "Goa",
    quote:
      "As a joint family with ancestral property, we needed precision. The team handled our will with warmth and professionalism.",
  },
  {
    name: "Neha Shah",
    city: "Powai, Mumbai",
    quote:
      "My late father never wrote a will — the aftermath was painful. I refuse to leave my daughter with that burden. Thank you WillSeva.",
  },
];
